import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import { IconComponent } from '@domgen/dgx-fe-components/icon';

@Component({
  selector:
    'us-registration-appliance-details-stepped-wib-form-registration-code-confirmation-panel-wib',
  standalone: true,
  imports: [IconComponent, CardComponent],
  templateUrl:
    './appliance-details-stepped-wib-form-registration-code-confirmation-panel-wib.component.html',
  styleUrls: [
    './appliance-details-stepped-wib-form-registration-code-confirmation-panel-wib.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceDetailsSteppedWibFormRegistrationCodeConfirmationPanelWibComponent {
  @Input() modelNumber?: string;
  @Input() serialNumber?: string;
  @Input() icon = 'washing-machine';
  @Input() appliance?: string;
  @Input() brandName?: string;
}
